/**
 * Backgammon の TypeScript 表現 (mixed-engine の serde 形と一致)。
 */

export type Side = 'First' | 'Second';

export interface BgPoint {
  owner: Side | null;
  count: number;
}

export interface BgTurnEntry {
  mv: BgMove;
  hit: boolean;
}

export interface BgState {
  points: BgPoint[]; // length 24
  bar: [number, number];   // [Host, Guest]
  off: [number, number];
  side: Side;
  dice: number[];
  round: number;
  outcome: { winner: Side } | null;
  /** このターン内に打った手 (EndTurn でクリア)。 Undo の有無判定に使う。 */
  turn_history?: BgTurnEntry[];
}

export type BgMove =
  | { enter: { dice: number } }
  | { step: { from: number; dice: number } }
  | { bear_off: { from: number; dice: number } }
  | 'end_turn'
  | 'undo';

/**
 * 盤に重ねる矢印 1 本 (1 駒の 1 区間)。 点は絶対座標 1..24、 'bar' は盤を見ている側の
 * バー、 'off' は盤を見ている側のゴール。 同じ駒の連続移動は区間ごとに並べる。
 * パズルの答え表示とチュートリアルで使う (BackgammonBoard の `arrows`)。
 */
export interface BgArrow {
  from: number | 'bar';
  to: number | 'off';
  hit?: boolean;
  /** 色。 best = 正解 / mine = 自分の手 / plain = その他。 */
  tone?: 'best' | 'mine' | 'plain';
}

export function isEnter(m: BgMove): m is { enter: { dice: number } } {
  return typeof m === 'object' && 'enter' in m;
}
export function isStep(m: BgMove): m is { step: { from: number; dice: number } } {
  return typeof m === 'object' && 'step' in m;
}
export function isBearOff(m: BgMove): m is { bear_off: { from: number; dice: number } } {
  return typeof m === 'object' && 'bear_off' in m;
}
export function isEndTurn(m: BgMove): m is 'end_turn' {
  return m === 'end_turn';
}
export function isUndo(m: BgMove): m is 'undo' {
  return m === 'undo';
}
